import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '../../../core/services/user.service';

@Pipe({
    name: 'userMetaDataByKey',
    standalone: false
})
export class UserMetaDataByKeyPipe implements PipeTransform {
    constructor(private readonly userService: UserService) {
    }

    transform(metaKey: string): Observable<boolean> {
        return this.userService.listenToUserMetaChanges(metaKey);
    }
}